import { render } from "./LatestJobs.vue?vue&type=template&id=35e20253"
import script from "./LatestJobs.vue?vue&type=script&lang=js"
export * from "./LatestJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__